module.exports = __webpack_public_path__ + "img/icons/attachment-upload/sync-799e5e8c048ede6a1af0d31467d89c1c.svg";